import React from "react";
import { CPT_CODES } from "@/lib/content";

export const CptTable = () => {
  return (
    <div className="overflow-x-auto border border-sage/60 rounded-[2px]" data-testid="cpt-table">
      <table className="w-full text-left border-collapse min-w-[560px]">
        <thead>
          <tr className="bg-spruce text-bone">
            <th className="tabular text-xs uppercase tracking-wider px-4 py-3 font-medium">Code</th>
            <th className="text-xs uppercase tracking-wider px-4 py-3 font-medium">What it covers</th>
            <th className="text-xs uppercase tracking-wider px-4 py-3 font-medium">Requirement</th>
          </tr>
        </thead>
        <tbody>
          {CPT_CODES.map((c, i) => (
            <tr key={c.code} className={i % 2 ? "bg-bone" : "bg-bone/60"}>
              <td className="tabular text-base font-medium text-brass px-4 py-4 align-top border-t border-sage/40">
                {c.code}
              </td>
              <td className="text-sm text-ink px-4 py-4 align-top border-t border-sage/40">{c.title}</td>
              <td className="text-sm text-ink/80 px-4 py-4 align-top border-t border-sage/40 leading-relaxed">
                {c.requirement}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CptTable;
